import { render, staticRenderFns } from "./ProfilePic.vue?vue&type=template&id=04b782a6&scoped=true&"
import script from "./ProfilePic.vue?vue&type=script&lang=js&"
export * from "./ProfilePic.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePic.vue?vue&type=style&index=0&id=04b782a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b782a6",
  null
  
)

export default component.exports